import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AvDataContextWithExternalProjectionsProvider } from '../../../../context/AvContextProvider';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout')({
  component: ExternalProjectionLayout,
});

function ExternalProjectionLayout() {
  return (
    <AvDataContextWithExternalProjectionsProvider>
      <Outlet />
    </AvDataContextWithExternalProjectionsProvider>
  );
}
